import { ISortObject } from 'src/components';

export const DEFAULT_SORT_ORDER: ISortObject = {
  field: 'deviceName',
  direction: 'ASC',
};

export const NMT_SOURCE_ID_PREFIX = 'nmt';
export const NMT_LIST_PAGE_SIZE = 100;
